// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.content {
  display: inline-block;
  z-index: 5;
  position: relative;
}
.availableAccess {
  margin-top: 15px;
}
.card-content-left {
  height: 50px;
}
.card-content-right {
  height: 50px;
}
.card-content-full label {
  display: block;
  margin-top: 10px;
}
.text-wrapper {
  width: 100%;
}
.disabledInput {
  margin-left: 9px;
}
.cardButton {
  margin-top: 10px;
  text-align: right;
}
.status {
  margin-top: 10px;
}
.no-margin-bottom {
  margin-bottom: 0px;
}
.px-10 {
  padding-left: 10px;
  padding-right: 10px;
}
.mb-15 {
  margin-bottom: 15px;
}
.card-container {
  margin-right: -10px;
  margin-left: -10px;
}
oir-collapsible-card.home-collapsible-card ::ng-deep div.collapsible-card ::ng-deep div.collapsible-content {
  overflow: inherit;
  padding: 20px;
}
.radioLabel {
  margin-left: 5px;
}
.is-edit span.invalid-error {
  margin-top: 0px;
  margin-bottom: 10px;
}
.update-btn {
  margin-bottom: 5px;
}
:host ::ng-deep oir-singleselect.invalid .select-container .input-container {
  background-color: #ffe5e9;
  color: #c30e2e;
  border: 1px solid #c30e2e;
}
.is-edit input.invalid {
  background-color: #ffe5e9;
  color: #c30e2e;
  border: 1px solid #c30e2e;
}
.invalid-email-domain {
  color: #c30e2e;
}
`, "",{"version":3,"sources":["webpack://./src/app/home/home.component.less"],"names":[],"mappings":"AAAA;EACE,qBAAA;EACA,UAAA;EACA,kBAAA;AACF;AAEA;EACE,gBAAA;AAAF;AAGA;EACE,YAAA;AADF;AAIA;EACE,YAAA;AAFF;AAKA;EACE,cAAA;EACA,gBAAA;AAHF;AAMA;EACE,WAAA;AAJF;AAOA;EACE,gBAAA;AALF;AAQA;EACE,gBAAA;EACA,iBAAA;AANF;AASA;EACE,gBAAA;AAPF;AAUA;EACE,kBAAA;AARF;AAWA;EACE,kBAAA;EACA,mBAAA;AATF;AAYA;EACE,mBAAA;AAVF;AAaA;EACE,mBAAA;EACA,kBAAA;AAXF;AAcA;EAGM,iBAAA;EACA,aAAA;AAdN;AAmBA;EACE,gBAAA;AAjBF;AAoBA;EACE,eAAA;EACA,mBAAA;AAlBF;AAqBA;EACE,kBAAA;AAnBF;AAuBE;EAGM,yBAAA;EACA,cAAA;EACA,yBAAA;AAvBR;AA6BA;EAEI,yBAAA;EACA,cAAA;EACA,yBAAA;AA5BJ;AAgCA;EACE,cAAA;AA9BF","sourcesContent":[".content {\n  display: inline-block;\n  z-index: 5;\n  position: relative;\n}\n\n.availableAccess {\n  margin-top: 15px;\n}\n\n.card-content-left {\n  height: 50px;\n}\n\n.card-content-right {\n  height: 50px;\n}\n\n.card-content-full label {\n  display: block;\n  margin-top: 10px;\n}\n\n.text-wrapper {\n  width: 100%;\n}\n\n.disabledInput{\n  margin-left: 9px;\n}\n\n.cardButton {\n  margin-top: 10px;\n  text-align: right;\n}\n\n.status {\n  margin-top: 10px;\n}\n\n.no-margin-bottom{\n  margin-bottom: 0px;\n}\n\n.px-10 {\n  padding-left: 10px;\n  padding-right: 10px;\n}\n\n.mb-15 {\n  margin-bottom: 15px;\n}\n\n.card-container {\n  margin-right: -10px;\n  margin-left: -10px;\n}\n\noir-collapsible-card.home-collapsible-card {\n  ::ng-deep div.collapsible-card {\n    ::ng-deep div.collapsible-content {\n      overflow: inherit;\n      padding: 20px;\n    }\n  }\n}\n\n.radioLabel {\n  margin-left: 5px;\n}\n\n.is-edit span.invalid-error {\n  margin-top: 0px; \n  margin-bottom: 10px;\n}\n\n.update-btn {\n  margin-bottom:5px;\n}\n\n:host ::ng-deep oir-singleselect {\n  &.invalid {\n    .select-container {\n      .input-container {\n        background-color: #ffe5e9;\n        color: #c30e2e;\n        border: 1px solid #c30e2e;\n      }\n    }\n  }\n}\n\n.is-edit {\n  input.invalid {\n    background-color: #ffe5e9;\n    color: #c30e2e;\n    border: 1px solid #c30e2e;\n  }\n}\n\n.invalid-email-domain{\n  color:#c30e2e;\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
